module.exports = __webpack_public_path__ + "media/images/190630-CMN-Nestle-5275-06647b88.jpg";